import React from 'react'
import { PageHeader, PageContent } from 'SRC/ui'
import { getAppLoading } from 'SRC/modules/common/selectors'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Preloader } from 'SRC/ui/Preloader'

export class Messages extends React.Component {
  render () {
    return (
      [
        <PageHeader key='header'>Moje poruke</PageHeader>,
        <PageContent key='content'>
          <div className='poruke-pretraga'>
            <div className='custom-select'>
              <a href='#'><i className='ico-primljene-poruke ico' />Primljene poruke</a>
              <ul>
                <li><a href='#'><i className='ico-primljene-poruke ico' />Primljene poruke</a></li>
                <li>
                  <a href='#'>
                    <i className='ico-novost-pregledi ico ico neprocitane-poruke-custom-select' />Nepročitane poruke
                  </a>
                </li>
                <li><a href='#'><i className='ico-poslate-poruke ico' />Poslate poruke</a></li>
                <li><a href='#'><i className='ico-sacuvaj-oglas ico' />Sačuvane poruke</a></li>
              </ul>
            </div>
            <div className='input-pretraga'>
              <input type='text' placeholder='Pretraži poruke...' />
              <button><i className='ico-pretraga-text-search-lupa ico' /></button>
            </div>
          </div>
          <div className='poruke-akcije'>
            <div className='poruke-akcije-left'>
              <a href='#'>
                <input type='checkbox' id='oznaci-sve' />
                <label htmlFor='oznaci-sve'>Označi sve</label>
              </a>
              <a href='#'>Poništi akciju</a>
            </div>
            <div className='poruke-akcije-right'>
              <div className='poruke-akcija-sacuvaj'>
                <a href='#'>
                  <i className='ico-user-sacuvaj-korisnika ico' />
                  <p>Sačuvaj</p>
                </a>
              </div>
              <div className='poruke-akcija-obrisi'>
                <a href='#'>
                  <i className='ico-obrisati ico' />
                  <p>Obriši</p>
                </a>
              </div>
            </div>
          </div>
          <div className='poruke-content'>
            <div className='poruke-item nova-poruka'>
              <a href='#'>
                <div className='poruke-item-img'>
                  <input type='checkbox' />
                  <i className='ico-user-avatar-musko ico' />
                </div>
                <div className='poruke-item-content'>
                  <div className='poruke-item-content-user-status'>
                    <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                  </div>
                  <div className='poruke-item-content-text'>
                    <p>
                      <span className='naslov-poruke'>
                        Volkswagen - Touareg 3.0tdi:
                      </span> Da li je zaključan na mrežu ili iCloud...
                    </p>
                  </div>
                </div>
                <div className='poruke-item-vreme'>
                  <p>prije 1h</p>
                </div>
                <div className='poruke-item-akcije'>
                  <span><i className='ico-user-sacuvaj-korisnika ico' /></span>
                  <span><i className='ico-obrisati ico' /></span>
                </div>
              </a>
            </div>
            <div className='poruke-item nova-poruka'>
              <a href='#'>
                <div className='poruke-item-img'>
                  <input type='checkbox' />
                  <img src='https://placehold.it/40x40x' alt='' />
                </div>
                <div className='poruke-item-content'>
                  <div className='poruke-item-content-user-status'>
                    <span className='user-online-status online' /><p>Aleksandar (AG-009)</p>
                  </div>
                  <div className='poruke-item-content-text'>
                    <p><span className='naslov-poruke'>
                    Poruka od korisnika:</span> Iskoristite priliku za bijeg u prirodu...
                    </p>
                  </div>
                </div>
                <div className='poruke-item-vreme'>
                  <p>prije 3h</p>
                </div>
                <div className='poruke-item-akcije'>
                  <span><i className='ico-user-sacuvaj-korisnika ico' /></span>
                  <span><i className='ico-obrisati ico' /></span>
                </div>
              </a>
            </div>
            <div className='poruke-item'>
              <a href='#'>
                <div className='poruke-item-img'>
                  <input type='checkbox' />
                  <i className='ico-user-avatar-zensko ico' />
                </div>
                <div className='poruke-item-content'>
                  <div className='poruke-item-content-user-status'>
                    <span className='user-online-status online' /><p>Marijana (BG-243)</p>
                  </div>
                  <div className='poruke-item-content-text'>
                    <p>
                      <span className='naslov-poruke'>
                        Zahtev za kupovinu:
                      </span>
                      Zdravo, želim započeti kupovinu artikla...
                    </p>
                  </div>
                </div>
                <div className='poruke-item-vreme'>
                  <p>Juče, 11:35h</p>
                </div>
                <div className='poruke-item-akcije'>
                  <span><i className='ico-user-sacuvaj-korisnika ico' /></span>
                  <span><i className='ico-obrisati ico' /></span>
                </div>
              </a>
            </div>
            <div className='poruke-item'>
              <a href='#'>
                <div className='poruke-item-img'>
                  <input type='checkbox' />
                  <i className='ico-user-avatar-prodavnica ico' />
                </div>
                <div className='poruke-item-content'>
                  <div className='poruke-item-content-user-status'>
                    <span className='user-online-status online' /><p>Zoki Mobile 10+ (BD-107)</p>
                  </div>
                  <div className='poruke-item-content-text'>
                    <p>
                      <span className='naslov-poruke'>
                        Volkswagen - Touareg 3.0tdi:
                      </span> Zdravo, želim pitati da li je telefon dos...
                    </p>
                  </div>
                </div>
                <div className='poruke-item-vreme'>
                  <p>prije 15 dana</p>
                </div>
                <div className='poruke-item-akcije'>
                  <span><i className='ico-user-sacuvaj-korisnika ico' /></span>
                  <span><i className='ico-obrisati ico' /></span>
                </div>
              </a>
            </div>
            <div className='poruke-item'>
              <a href='#'>
                <div className='poruke-item-img'>
                  <input type='checkbox' />
                  <i className='ico-user-avatar-musko ico' />
                </div>
                <div className='poruke-item-content'>
                  <div className='poruke-item-content-user-status'>
                    <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                  </div>
                  <div className='poruke-item-content-text'>
                    <p>
                      <span className='naslov-poruke'>Volkswagen - Touareg 3.0tdi:</span>
                      Da li je zaključan na mrežu ili iCloud...
                    </p>
                  </div>
                </div>
                <div className='poruke-item-vreme'>
                  <p>03.08.2016.</p>
                </div>
                <div className='poruke-item-akcije'>
                  <span><i className='ico-user-sacuvaj-korisnika ico' /></span>
                  <span><i className='ico-obrisati ico' /></span>
                </div>
              </a>
            </div>
            <div className='poruke-item'>
              <a href='#'>
                <div className='poruke-item-img'>
                  <input type='checkbox' />
                  <i className='ico-user-avatar-musko ico' />
                </div>
                <div className='poruke-item-content'>
                  <div className='poruke-item-content-user-status'>
                    <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                  </div>
                  <div className='poruke-item-content-text'>
                    <p><span className='naslov-poruke'>Volkswagen - Touareg 3.0tdi:</span>
                      Da li je zaključan na mrežu ili iCloud...
                    </p>
                  </div>
                </div>
                <div className='poruke-item-vreme'>
                  <p>03.08.2016.</p>
                </div>
                <div className='poruke-item-akcije'>
                  <span><i className='ico-user-sacuvaj-korisnika ico' /></span>
                  <span><i className='ico-obrisati ico' /></span>
                </div>
              </a>
            </div>
            <div className='poruke-item'>
              <a href='#'>
                <div className='poruke-item-img'>
                  <input type='checkbox' />
                  <i className='ico-user-avatar-musko ico' />
                </div>
                <div className='poruke-item-content'>
                  <div className='poruke-item-content-user-status'>
                    <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                  </div>
                  <div className='poruke-item-content-text'>
                    <p>
                      <span className='naslov-poruke'>
                        Volkswagen - Touareg 3.0tdi:
                      </span> Da li je zaključan na mrežu ili iCloud...
                    </p>
                  </div>
                </div>
                <div className='poruke-item-vreme'>
                  <p>03.08.2016.</p>
                </div>
                <div className='poruke-item-akcije'>
                  <span><i className='ico-user-sacuvaj-korisnika ico' /></span>
                  <span><i className='ico-obrisati ico' /></span>
                </div>
              </a>
            </div>
            <div className='poruke-item'>
              <a href='#'>
                <div className='poruke-item-img'>
                  <input type='checkbox' />
                  <i className='ico-user-avatar-musko ico' />
                </div>
                <div className='poruke-item-content'>
                  <div className='poruke-item-content-user-status'>
                    <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                  </div>
                  <div className='poruke-item-content-text'>
                    <p>
                      <span className='naslov-poruke'>Volkswagen - Touareg 3.0tdi:</span>
                      Da li je zaključan na mrežu ili iCloud...
                    </p>
                  </div>
                </div>
                <div className='poruke-item-vreme'>
                  <p>03.08.2016.</p>
                </div>
                <div className='poruke-item-akcije'>
                  <span><i className='ico-user-sacuvaj-korisnika ico' /></span>
                  <span><i className='ico-obrisati ico' /></span>
                </div>
              </a>
            </div>
            <div className='poruke-item'>
              <a href='#'>
                <div className='poruke-item-img'>
                  <input type='checkbox' />
                  <i className='ico-user-avatar-musko ico' />
                </div>
                <div className='poruke-item-content'>
                  <div className='poruke-item-content-user-status'>
                    <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                  </div>
                  <div className='poruke-item-content-text'>
                    <p>
                      <span className='naslov-poruke'>Volkswagen - Touareg 3.0tdi:</span>
                      Da li je zaključan na mrežu ili iCloud...
                    </p>
                  </div>
                </div>
                <div className='poruke-item-vreme'>
                  <p>03.08.2016.</p>
                </div>
                <div className='poruke-item-akcije'>
                  <span><i className='ico-user-sacuvaj-korisnika ico' /></span>
                  <span><i className='ico-obrisati ico' /></span>
                </div>
              </a>
            </div>
            <div className='poruke-item'>
              <a href='#'>
                <div className='poruke-item-img'>
                  <input type='checkbox' />
                  <i className='ico-user-avatar-musko ico' />
                </div>
                <div className='poruke-item-content'>
                  <div className='poruke-item-content-user-status'>
                    <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                  </div>
                  <div className='poruke-item-content-text'>
                    <p>
                      <span className='naslov-poruke'>Volkswagen - Touareg 3.0tdi:</span>
                      Da li je zaključan na mrežu ili iCloud...
                    </p>
                  </div>
                </div>
                <div className='poruke-item-vreme'>
                  <p>03.08.2016.</p>
                </div>
                <div className='poruke-item-akcije'>
                  <span><i className='ico-user-sacuvaj-korisnika ico' /></span>
                  <span><i className='ico-obrisati ico' /></span>
                </div>
              </a>
            </div>
            <div className='poruke-item'>
              <a href='#'>
                <div className='poruke-item-img'>
                  <input type='checkbox' />
                  <i className='ico-user-avatar-musko ico' />
                </div>
                <div className='poruke-item-content'>
                  <div className='poruke-item-content-user-status'>
                    <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                  </div>
                  <div className='poruke-item-content-text'>
                    <p>
                      <span className='naslov-poruke'>Volkswagen - Touareg 3.0tdi:</span>
                      Da li je zaključan na mrežu ili iCloud...
                    </p>
                  </div>
                </div>
                <div className='poruke-item-vreme'>
                  <p>03.08.2016.</p>
                </div>
                <div className='poruke-item-akcije'>
                  <span><i className='ico-user-sacuvaj-korisnika ico' /></span>
                  <span><i className='ico-obrisati ico' /></span>
                </div>
              </a>
            </div>
            <div className='poruke-item'>
              <a href='#'>
                <div className='poruke-item-img'>
                  <input type='checkbox' />
                  <i className='ico-user-avatar-musko ico' />
                </div>
                <div className='poruke-item-content'>
                  <div className='poruke-item-content-user-status'>
                    <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                  </div>
                  <div className='poruke-item-content-text'>
                    <p>
                      <span className='naslov-poruke'>Volkswagen - Touareg 3.0tdi:</span>
                      Da li je zaključan na mrežu ili iCloud...
                    </p>
                  </div>
                </div>
                <div className='poruke-item-vreme'>
                  <p>03.08.2016.</p>
                </div>
                <div className='poruke-item-akcije'>
                  <span><i className='ico-user-sacuvaj-korisnika ico' /></span>
                  <span><i className='ico-obrisati ico' /></span>
                </div>
              </a>
            </div>
            <div className='poruke-item'>
              <a href='#'>
                <div className='poruke-item-img'>
                  <input type='checkbox' />
                  <i className='ico-user-avatar-musko ico' />
                </div>
                <div className='poruke-item-content'>
                  <div className='poruke-item-content-user-status'>
                    <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                  </div>
                  <div className='poruke-item-content-text'>
                    <p>
                      <span className='naslov-poruke'>Volkswagen - Touareg 3.0tdi:</span>
                      Da li je zaključan na mrežu ili iCloud...
                    </p>
                  </div>
                </div>
                <div className='poruke-item-vreme'>
                  <p>03.08.2016.</p>
                </div>
                <div className='poruke-item-akcije'>
                  <span><i className='ico-user-sacuvaj-korisnika ico' /></span>
                  <span><i className='ico-obrisati icoico-obrisati ico' /></span>
                </div>
              </a>
            </div>
            <div className='poruke-item'>
              <a href='#'>
                <div className='poruke-item-img'>
                  <input type='checkbox' />
                  <i className='ico-user-avatar-musko ico' />
                </div>
                <div className='poruke-item-content'>
                  <div className='poruke-item-content-user-status'>
                    <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                  </div>
                  <div className='poruke-item-content-text'>
                    <p>
                      <span className='naslov-poruke'>Volkswagen - Touareg 3.0tdi:</span>
                      Da li je zaključan na mrežu ili iCloud...
                    </p>
                  </div>
                </div>
                <div className='poruke-item-vreme'>
                  <p>03.08.2016.</p>
                </div>
                <div className='poruke-item-akcije'>
                  <span><i className='ico-user-sacuvaj-korisnika ico' /></span>
                  <span><i className='ico-obrisati ico' /></span>
                </div>
              </a>
            </div>
            <div className='poruke-item'>
              <a href='#'>
                <div className='poruke-item-img'>
                  <input type='checkbox' />
                  <i className='ico-user-avatar-musko ico' />
                </div>
                <div className='poruke-item-content'>
                  <div className='poruke-item-content-user-status'>
                    <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                  </div>
                  <div className='poruke-item-content-text'>
                    <p>
                      <span className='naslov-poruke'>Volkswagen - Touareg 3.0tdi:</span>
                      Da li je zaključan na mrežu ili iCloud...
                    </p>
                  </div>
                </div>
                <div className='poruke-item-vreme'>
                  <p>03.08.2016.</p>
                </div>
                <div className='poruke-item-akcije'>
                  <span><i className='ico-user-sacuvaj-korisnika ico' /></span>
                  <span><i className='ico-obrisati ico' /></span>
                </div>
              </a>
            </div>
            <div className='poruke-item'>
              <a href='#'>
                <div className='poruke-item-img'>
                  <input type='checkbox' />
                  <i className='ico-user-avatar-musko ico' />
                </div>
                <div className='poruke-item-content'>
                  <div className='poruke-item-content-user-status'>
                    <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                  </div>
                  <div className='poruke-item-content-text'>
                    <p>
                      <span className='naslov-poruke'>Volkswagen - Touareg 3.0tdi:</span>
                      Da li je zaključan na mrežu ili iCloud...
                    </p>
                  </div>
                </div>
                <div className='poruke-item-vreme'>
                  <p>03.08.2016.</p>
                </div>
                <div className='poruke-item-akcije'>
                  <span><i className='ico-user-sacuvaj-korisnika ico' /></span>
                  <span><i className='ico-obrisati ico' /></span>
                </div>
              </a>
            </div>
            <div className='poruke-item'>
              <a href='#'>
                <div className='poruke-item-img'>
                  <input type='checkbox' />
                  <i className='ico-user-avatar-musko ico' />
                </div>
                <div className='poruke-item-content'>
                  <div className='poruke-item-content-user-status'>
                    <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                  </div>
                  <div className='poruke-item-content-text'>
                    <p>
                      <span className='naslov-poruke'>Volkswagen - Touareg 3.0tdi:</span>
                      Da li je zaključan na mrežu ili iCloud...
                    </p>
                  </div>
                </div>
                <div className='poruke-item-vreme'>
                  <p>03.08.2016.</p>
                </div>
                <div className='poruke-item-akcije'>
                  <span><i className='ico-user-sacuvaj-korisnika ico' /></span>
                  <span><i className='ico-obrisati ico' /></span>
                </div>
              </a>
            </div>
            <div className='poruke-item'>
              <a href='#'>
                <div className='poruke-item-img'>
                  <input type='checkbox' />
                  <i className='ico-user-avatar-musko ico' />
                </div>
                <div className='poruke-item-content'>
                  <div className='poruke-item-content-user-status'>
                    <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                  </div>
                  <div className='poruke-item-content-text'>
                    <p>
                      <span className='naslov-poruke'>Volkswagen - Touareg 3.0tdi:</span>
                      Da li je zaključan na mrežu ili iCloud...
                    </p>
                  </div>
                </div>
                <div className='poruke-item-vreme'>
                  <p>03.08.2016.</p>
                </div>
                <div className='poruke-item-akcije'>
                  <span><i className='ico-user-sacuvaj-korisnika ico' /></span>
                  <span><i className='ico-obrisati ico' /></span>
                </div>
              </a>
            </div>
            <div className='poruke-item'>
              <a href='#'>
                <div className='poruke-item-img'>
                  <input type='checkbox' />
                  <i className='ico-user-avatar-musko ico' />
                </div>
                <div className='poruke-item-content'>
                  <div className='poruke-item-content-user-status'>
                    <span className='user-online-status offline' /><p>Nikola (AA-001)</p>
                  </div>
                  <div className='poruke-item-content-text'>
                    <p>
                      <span className='naslov-poruke'>Volkswagen - Touareg 3.0tdi:</span>
                      Da li je zaključan na mrežu ili iCloud...
                    </p>
                  </div>
                </div>
                <div className='poruke-item-vreme'>
                  <p>03.08.2016.</p>
                </div>
                <div className='poruke-item-akcije'>
                  <span><i className='ico-user-sacuvaj-korisnika ico' /></span>
                  <span><i className='ico-obrisati ico' /></span>
                </div>
              </a>
            </div>
          </div>
          <div className='poruke-pagination'>
            <ul>
              <li><a href='#'>prethodna</a></li>
              <li className='active'><a href='#'>1</a></li>
              <li><a href='#'>2</a></li>
              <li><a href='#'>3</a></li>
              <li><a href='#'>4</a></li>
              <li><a href='#'>5</a></li>
              <li><a href='#'>6</a></li>
              <li><a href='#'>...</a></li>
              <li><a href='#'>99</a></li>
              <li><a href='#'>100</a></li>
              <li><a href='#'>sledeća</a></li>
            </ul>
          </div>
          {this.props.isLoading ? <Preloader /> : null}
        </PageContent>
      ]
    )
  }
}

const mapStateToProps = state => ({
  isLoading: getAppLoading(state)
})

Messages.propTypes = {
  isLoading: PropTypes.bool.isRequired
}

Messages.defaultProps = {
  isLoading: false
}

export default connect(mapStateToProps)(Messages)
